<template>
    <!-- 通用底部  :class="{fixedFooter:fixed}"-->
    <div class="footer">
        <dl class="friendship-link pt20" v-show="isShow==true && listFlag">
            <dt class="title">友情链接</dt>
            <dd class="link-list pb20">
                <div v-for="(item,index) in friendShipLinks" :key="index">
                    <span @click="toLink(item.link)">{{item.title}}</span>
                </div>
            </dd>
        </dl>
        <div style="text-align:center;color:#fff;font-size:12px;cursor:pointer;" class="pt20" @click="toLink('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+policeRecordNumber)">
            <img src="../assets/images/police.png" class="wh20">&nbsp;&nbsp;&nbsp;{{policeRecord}}
        </div>
        <div class="copy-right pt10 pb20 tc">{{copyright}}&nbsp;&nbsp;&nbsp;<span style="cursor:pointer;" @click="toLink('https://beian.miit.gov.cn')">{{icpRecord}}</span></div>
    </div>
</template>
<script>
export default {
    props: ['isShow'],
    data() {
        return {
           friendShipLinks:[],
           listFlag: false
        };
    },
    computed: {
        copyright(){
            return this.$store.getters.getCopyright;
        },
        icpRecord(){
            return this.$store.getters.getIcpRecord;
        },
        policeRecord(){
            return this.$store.getters.getPoliceRecord;
        },
        policeRecordNumber(){
            return this.$store.getters.getPoliceRecordNumber;
        }
    },
    created() {

    },
    mounted() {
        this.getFriendShipLinks();
    },
    watch: {

    },
    methods: {
        getFriendShipLinks(){
            this.$axios.post(this.api.index.friendShipLinks,{},res =>{
                this.friendShipLinks = res.data;

                if(this.friendShipLinks.length){
                    this.listFlag = true;
                }
            },err =>{
                this.friendShipLinks = [];
            });
        },
        toLink(url){
            window.open(url);
        }
    },
    components: {

    },
};
</script>
<style scoped>
/* 通用底部 */
.fixedFooter{position:fixed;bottom:0;left:0;width:100%;}
.footer{ position:absolute;bottom:0;left:0;width:100%;background:rgba(26,48,57,1);}
.friendship-link{width:1200px;margin: 0 auto;color:#CCCCCC;}
.friendship-link .title{font-size:18px;}
.friendship-link .link-list{font-size:12px;border-bottom:1px solid #364951;overflow: hidden;}
.link-list div{float:left;width:33.33%;padding-top:10px; height:17px;line-height:17px;}
.link-list div span{color:#CCCCCC;cursor: pointer;}
.link-list div span:hover{color:#fff;}
.copy-right{font-size:12px;color:rgba(255,255,255,1);}
</style>


// WEBPACK FOOTER //
// src/components/navFooter.vue